const IST = 'Asia/Kolkata';
const dayOf = (d: Date) => new Intl.DateTimeFormat('en-CA', { timeZone: IST }).format(d);

export const formatIstDate = (iso?: string | null): string =>
    iso ? new Intl.DateTimeFormat('en-IN', { timeZone: IST, day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }).format(new Date(iso)) : '—';

export const formatIstTime = (iso: string): string =>
    new Intl.DateTimeFormat('en-IN', { timeZone: IST, hour: 'numeric', minute: '2-digit' }).format(new Date(iso));

export const todayLabel = (): string =>
    new Intl.DateTimeFormat('en-IN', { timeZone: IST, weekday: 'long', day: 'numeric', month: 'long' }).format(new Date());

// Whole IST calendar days since the item first appeared (0 = appeared today).
export const ageDays = (firstSeenAt: string): number => {
    const a = new Date(dayOf(new Date(firstSeenAt)) + 'T00:00:00Z').getTime();
    const b = new Date(dayOf(new Date()) + 'T00:00:00Z').getTime();
    return Math.max(0, Math.round((b - a) / 86400000));
};

export const ageLabel = (firstSeenAt: string): string => {
    const d = ageDays(firstSeenAt);
    return d === 0 ? 'New today' : d === 1 ? 'Open 1 day' : `Open ${d} days`;
};
